import ImagesFragment = Queries.ImagesFragment
import ImageFragment = Queries.ImageFragment
import { ImageType, ImagesType, FALLBACK_IMAGE } from '../../utils/image'
import { useStrapiImageMapper } from '../../utils/mapStrapiImageToStatic'

function getImageUrl(imageFileIdentifier: string): string | undefined {
  const { mapStrapiImageToGatsby } = useStrapiImageMapper()
  return mapStrapiImageToGatsby(imageFileIdentifier)
}

export function mapFragmentToImage(fragment: ImageFragment | null): ImageType {

  if (!fragment || !fragment.url || !fragment.hash || !fragment.ext)
    return FALLBACK_IMAGE

  const imageFileIdentifier = `${fragment.hash}${fragment.ext}`
  const imageUrl = getImageUrl(imageFileIdentifier)
  if (!imageUrl) return FALLBACK_IMAGE

  return {
    alternativeText: fragment.alternativeText ?? '',
    url: imageUrl,
    height: fragment.height ?? 0,
    width: fragment.width ?? 0,
  }
}

export function mapFragmentToImages(fragment: ImagesFragment | null): ImagesType {
  return {
    desktopImage: mapFragmentToImage(fragment?.desktopImage ?? null),
    mobileImage: mapFragmentToImage(fragment?.mobileImage ?? null),
  }
}
